import { Grid, Col } from '@koaly/grid';
import { getFontTokenStyle, getVariantToken, getSizeToken } from '@koaly/mixins';
import { createElement } from 'react';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import { Button } from '../Button/Button.js';
import { ButtonGroup } from '../Button/ButtonGroup/ButtonGroup.js';
import { Container } from '../Container/Container.js';
import { Link } from '../Link/Link.js';
import { Portal } from '../Portal/Portal.js';

const StyledCookieBar = styled(Container) `
  ${getFontTokenStyle('label', 'medium', undefined, 'bold')};
  z-index: ${({ zIndex }) => zIndex};
  width: 100%;
  box-sizing: border-box;
  position: ${({ floating }) => floating ? 'fixed' : 'relative'};
  bottom: ${({ floatingPosition }) => floatingPosition === 'bottom' ? 0 : undefined};
  top: ${({ floatingPosition }) => floatingPosition === 'top' ? 0 : undefined};
  color: ${getVariantToken('cookieBar', 'color')};
  background-color: ${getVariantToken('cookieBar', 'backgroundColor')};
  padding: ${getSizeToken('cookieBar', 'padding')};

  a {
    color: ${getVariantToken('cookieBar', 'color')};

    &:hover {
      color: ${getVariantToken('cookieBar', 'color')};
    }
  }
`;
const CookieBar = ({ children, acceptButtonText, manageButtonText, manageButtonOnClick, acceptButtonOnClick, open, floating, floatingPosition, zIndex, }) => {
    return (createElement(CSSTransition, { in: open, timeout: 0, unmountOnExit: true },
        createElement(Portal, null,
            createElement(StyledCookieBar, { floating: floating, floatingPosition: floatingPosition, zIndex: zIndex },
                createElement(Grid, { gutterRows: 10, gutter: 10 },
                    createElement(Col, { width: { xs: 1, s: 'stretch' }, valign: "center", flex: true }, children),
                    createElement(Col, { width: { xs: 1, s: 'stretch' }, flex: true, halign: { xs: 'left', s: 'right' }, valign: "center" },
                        createElement(ButtonGroup, { spacing: 8 },
                            manageButtonOnClick && manageButtonText &&
                                createElement(Link, { variant: "secondary", href: "#", onClick: manageButtonOnClick }, manageButtonText),
                            createElement(Button, { variant: "secondary", elevation: 2, onClick: acceptButtonOnClick }, acceptButtonText))))))));
};
CookieBar.defaultProps = {
    children: 'Wij maken op deze website gebruik van cookies om je de beste ervaring te bieden. Meer info.',
    acceptButtonText: 'Accepteer',
    manageButtonText: 'Beheer cookies',
    floatingPosition: 'bottom',
    open: false,
    zIndex: 100,
};

export { CookieBar };
//# sourceMappingURL=CookieBar.js.map
